export enum AddPartEnum {
  AddPart,
  RequestPart,
}
